import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5005 10H18V13L23 10.523L23 21.477L18 19V22H1V10H2.55051C1.90223 9.36474 1.5 8.47935 1.5 7.5C1.5 5.567 3.067 4 5 4C6.01874 4 6.93582 4.43525 7.57544 5.12993C7.9872 2.78327 10.0353 1 12.5 1C15.2614 1 17.5 3.23858 17.5 6C17.5 7.6356 16.7147 9.08777 15.5005 10ZM8.28962 8.69794C8.10893 9.19401 7.81923 9.63769 7.44949 10H9.49951C9.02297 9.64197 8.61249 9.20076 8.28962 8.69794Z"}}]};

const VideoCamera2Filled = Vue.extend<IconProps>({
  name: 'VideoCamera2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'video-camera-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default VideoCamera2Filled;
